// extracted by mini-css-extract-plugin
module.exports = {"loader":"_90oc-t2VWVnOR0bN_q37z","load1":"HI2PPCS0h2JTItSDgaDX2"};